export function useDynamicHeight() {
   //>> STATE ------------------------------------------------------
   let resizeObserver: ResizeObserver | null = null;
   const state = useState<Record<string, number>>("heightState", () => ({}));
   const elName = ref<string>("");
   //>> METHODS ------------------------------------------------------
   const setHeight = (name: string, height: number) => {
      document.documentElement.style.setProperty(`--${name}`, `${height}px`);
      state.value[name] = height;
   };

   if (import.meta.client) {
      resizeObserver = new ResizeObserver((entries) => {
         for (const entry of entries) {
            if (entry.contentRect) {
               setHeight(elName.value, entry.borderBoxSize[0].blockSize);
            }
         }
      });
   }

   // >> START ------------------------------------------------------
   const addDynamicEl = (name: string = "variable", el: HTMLElement | null = null) => {
      if (!el) return;
      setHeight(name, el.offsetHeight);
      elName.value = name;
      resizeObserver?.observe(el);
   };

   return { dynamicHeights: readonly(state), addDynamicEl };
}
